import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Observable } from 'rxjs';
import { CommonsService } from './commons.service';
import { MessagesService } from './messages.service';
import { Message, MessageService, MessageTypeEnum, RelationSubjectTypeEnum } from 'src/api/generated';
import { AuthService } from 'acl-cloud-lib';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  public dataSource: DataSource<Message, string>;
  public _message: BehaviorSubject<Message | undefined> = new BehaviorSubject<Message | undefined>(undefined);
  public message$: Observable<Message | undefined> = this._message.asObservable();
  public relationSubject: RelationSubjectTypeEnum[] = Object.values(RelationSubjectTypeEnum);
  public messageType: MessageTypeEnum[] = Object.values(MessageTypeEnum);

  protected user: any;

  tokenStorageService: any;

  constructor(
    private _commonSvc: CommonsService,
    private readonly _messageSvc: MessageService,
    private _spinner: NgxSpinnerService,
    private _msgSvc: MessagesService,
    private _authService: AuthService
  ) {
    this.dataSource = _commonSvc.makeAsyncDataSource<Message, string, MessageService>(this._messageSvc, undefined);
  }

  public SaveMessage(msg: Message): void {
    let dat: Message = {
      Id: msg.Id,
      Name: msg.Name,
      Version: msg.Version,
      Tags: msg.Tags,
      Created: msg.Created,
      Modified: msg.Modified,
      SourceId: msg.SourceId,
      MessageType: msg.MessageType,
      MessageContent: msg.MessageContent,
      ParentId: msg.ParentId,
      Attachments: msg.Attachments,
      Destinators: msg.Destinators,
      MessageSource: msg.MessageSource,
      Status: msg.Status // pridat Status podla cardu
    };

    
    if(this._authService.identityClaims != undefined && msg.MessageSource?.SubjectType?.toString() == "User") {
      let parts = this._authService.identityClaims['sub'].split(':');

      if(parts.length >= 1) {
        let middlePart = parts[1];
        let result = middlePart.replace(/-/g, '');
        if(dat.MessageSource){
          dat.MessageSource.SubjectId = result;
        } else {
          dat.MessageSource = {
            SubjectId: result,
            SubjectType: RelationSubjectTypeEnum.User
          }
        }
      } 
    }

    this._spinner.show();

    this._messageSvc.post(dat).subscribe({
      next:() => {
        setTimeout(() => {
          window.location.reload();
          this._spinner.hide();
        }, 200);
      },
      error: e => {
        setTimeout(() => {
          this._spinner.hide();
        }, 200);
      }
    });
  }
}
